import React from "react";

const Java_Sum_Digits = () => {
  return (
    <div>
      <h1>Java Sum Digits</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Sum Digits in Java.</p>
    </div>
  );
};

export default Java_Sum_Digits;
